import styled from 'styled-components';

const ContributorContainer = styled.div`
  display: flex;
`;

const TextContent = styled.div`
	display: flex;
	align-items: center;
`;

const ContributorName = styled.div`
	${(props) => props.theme.typography.headingXS}
`;

const ContributorAvatar = styled.img`
	border-radius: 50%;
	width: 3rem;
	height: 3rem;
	margin-right: 0.5rem;
`;

export const Contributor = ({ className, name, nationality, avatarUrl }) => (
    <ContributorContainer className={className}>
		<ContributorAvatar src={`/images/contributors/${avatarUrl}`} alt={`${name}'s avatar`} />
        <TextContent>
            {name && <ContributorName>{name}</ContributorName>}
        </TextContent>
    </ContributorContainer>
);